import React, { useState, useEffect } from 'react';
import './textSlider.css';

const quotes = [
  {
    en: "The real voyage of discovery consists not in seeking new landscapes, but in having new eyes.",
    tr: "Keşfe giden esas yolculuk; yeni diyarlar aramaktan değil, yeni gözlere sahip olmaktan geçer.",
    author: "Marcel Proust"
  },
  {
    en: "Transformation requires change. One of the things that must change is our relationship to our memories.",
    tr: "Dönüşüm değişim gerektirir. Değişmesi gereken şeylerden biri de hatıralarımızla olan ilişkimizdir.",
    author: "Peter A. Levine"
  },
  {
    en: "Trauma may be the most avoided, ignored, belittled, denied, misunderstood, and untreated cause of human suffering.",
    tr: "Travma, belki de insan ıstırabının en çok kaçınılan, göz ardı edilen, küçümsenen, reddedilen, yanlış anlaşılan ve tedavi edilmeyen nedenidir.",
    author: "Peter A. Levine"
  },
  {
    en: "When a young tree is injured, it grows around the wound. In this way, the tree’s growth around its past contributes to its uniqueness, its character, and its beauty.",
    tr: "Genç bir ağaç yaralandığında, o yaranın etrafından dolaşarak büyür. Ağacın geçmişinin çevresinden dönüp dolaşarak büyüme biçimi, onun eşsiz özgünlüğüne, karakterine ve güzelliğine katkıda bulunur.",
    author: "Peter A. Levine"
  },
  {
    en: "The paradox of trauma is that it has both the power to destroy and the power to transform and resurrect.",
    tr: "Travmanın paradoksu; hem yok etme gücüne, hem de dönüşme ve diriliş gücüne sahip olmasıdır.",
    author: "Peter A. Levine"
  },
  {
    en: "Shame dies when stories are told in safe places.",
    tr: "Hikâyeler güvenli alanlarda anlatıldığında, utanç ölür.",
    author: "Ann Voskamp"
  },
  {
    en: "Healing our own trauma does more than heal us — it also heals our children.",
    tr: "Bireysel travmayı iyileştirmek, sadece bizi iyileştirmekle kalmaz, çocuklarımızı da iyileştirir.",
    author: "Maggie Kline"
  },
  {
    en: "The only way we can change the way we feel is by becoming aware of our internal experience and learning to befriend what is going on inside ourselves.",
    tr: "Nasıl hissettiğimizi değiştirebilmemizin tek yolu, içsel deneyimimizin farkına varmak ve içimizde olanla arkadaş olmaktır.",
    author: "Bessel van der Kolk"
  },
  {
    en: "Recovery is not one and done. It is a lifelong journey that takes place one day, one step at a time.",
    tr: "İyileşme bir defalık değildir. Gün be gün, adım adım süren ömür boyu bir yolculuktur.",
    author: "Brittany Burgunder"
  },
  {
    en: "Trauma is personal. It does not disappear if it is not validated. When it is ignored or invalidated, the silent screams continue to echo inside.",
    tr: "Travma kişiseldir. Doğrulanmadığında kaybolmaz. Göz ardı edildiğinde ya da geçersiz kılındığında sessiz çığlıklar içeride yankılanmaya devam eder.",
    author: "Danielle Bernock"
  }
];

const TextSlider = () => {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * quotes.length));

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % quotes.length);
    }, 32000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="quote-container">
      <div className="quote-content" key={index}>
        <p className="quote-en">"{quotes[index].en}"</p>
        <p className="quote-tr">{quotes[index].tr}</p>
        <span className="quote-author">— {quotes[index].author}</span>
      </div>
    </div>
  );
};

export default TextSlider;